import { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { fetchEmployeesByStatus } from 'services/fetch-employees-by-status'
import { MainTemplate } from 'templates/MainTemplate'

import ChartStatus from './ChartStatus/index'
import EmployeeBooking from './EmployeesBooking/index'
import EmployeesNextPayment from './EmployeesNextPayment/index'
import { SkeletonHome } from './SkeletonHome'
import { EmployeesData } from './type'

export default function Home() {
  const [employees, setEmployees] = useState<EmployeesData>()
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    fetchEmployeesByStatus()
      .then((res) => {
        setEmployees(res)
      })
      .catch((err) => {
        if (err instanceof Error) {
          return toast.error(err.message)
        }

        return toast.error('Erro ao buscar dados')
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  if (isLoading) {
    return <SkeletonHome />
  }

  return (
    <MainTemplate>
      <section className="w-full p-20 flex justify-around gap-10 flex-wrap">
        <ChartStatus employees={employees?.status_percentages} />
        <EmployeeBooking employees={employees?.reservation_counts} />
        <EmployeesNextPayment employees={employees?.total_approximate_bill} />
      </section>
    </MainTemplate>
  )
}
